/**
 * Add-user: pure validation. Composes the shared identity rules
 * (`validateDraft`: first/last/email) with the Add-only licence-required rule,
 * mirroring what the flat `AddUser` page enforced inline. Pure: unit-tested
 * directly and reused by the slice's selector + saga.
 */
import { validateDraft } from '../../_shared/domain/user-draft.validation';
import type { AddUserDraft, AddValidationErrors } from './add-user-draft.model';

export function validateAddDraft(draft: AddUserDraft): AddValidationErrors {
  const errors: AddValidationErrors = { ...validateDraft(draft) };
  if (!draft.licenceId) errors.licenceId = 'Licence is required.';
  return errors;
}
